// ============================================================
// Ajustes de ESTA instalación: país (moneda, IVA, NIF/NIT, prefijo de
// WhatsApp) y, en las copias de prueba para clientes, cómo va la prueba.
// Se piden una vez al servidor antes de pintar la aplicación (index.js).
// Si no contesta a tiempo, España: tu ERP sale exactamente como siempre.
// ============================================================
const ESPANA = {
  pais: 'ES', nombrePais: 'España', moneda: 'EUR', simbolo: '€', locale: 'es-ES', decimales: 2,
  iva: 21, tiposIva: [0, 4, 10, 21], nif: 'NIF', nifEmpresa: 'NIF / CIF', docCliente: 'DNI / NIF', docCorto: 'NIF/DNI',
  ejemploDoc: '12345678A', tiposDocumento: ['DNI', 'NIE', 'Pasaporte'], nombreMoneda: 'euros',
  prefijoTel: '34', digitosTel: 9, ejemploMovil: '600000000', provincia: 'Provincia',
  billetes: [500, 200, 100, 50, 20, 10, 5], monedas: [2, 1, 0.5, 0.2, 0.1, 0.05, 0.02, 0.01],
};

let pais = { ...ESPANA };
let prueba = null;
let pedida = null;

function aplicar(d) {
  if (!d || !d.ok) return;
  pais = { ...ESPANA, ...(d.pais || {}) };
  prueba = d.prueba || null;
}

const pedir = () => fetch('/api/instancia', { cache: 'no-store' })
  .then(r => (r.ok ? r.json() : null))
  .then(d => { aplicar(d); return d; })
  .catch(() => null);

// Antes de pintar: como mucho `espera` ms
export function cargarInstancia(espera = 2500) {
  if (!pedida) pedida = Promise.race([pedir(), new Promise(ok => setTimeout(ok, espera))]);
  return pedida;
}
// Volver a preguntar (p. ej. los días que quedan de prueba)
export const refrescarInstancia = () => pedir().then(() => prueba);

export const datosPais = () => pais;
export const esEspana = () => pais.pais === 'ES';
export const simbolo = () => pais.simbolo;
export const ivaDefecto = () => pais.iva;
export const tiposIva = () => pais.tiposIva;
export const etiquetaNIF = () => pais.nif;
export const etiquetaDocCliente = () => pais.docCliente;
export const etiquetaDocCorto = () => pais.docCorto;
export const ejemploDoc = () => pais.ejemploDoc;
export const tiposDocumento = () => pais.tiposDocumento;
export const prefijoTel = () => pais.prefijoTel;
export const ejemploMovil = () => pais.ejemploMovil;
export const etiquetaProvincia = () => pais.provincia;
export const decimales = () => pais.decimales;
export const pasoImporte = () => (pais.decimales > 0 ? '0.01' : '1');
export const ejemploImporte = () => (pais.decimales > 0 ? '0.00' : '0');

// 1.234,56 € (España) · $ 1.234.567 (Colombia)
export function formatoMoneda(v) {
  return new Intl.NumberFormat(pais.locale, { style: 'currency', currency: pais.moneda,
    minimumFractionDigits: pais.decimales, maximumFractionDigits: pais.decimales }).format(Number(v) || 0);
}
// Leer un importe escrito a mano: "12,50" (España) · "1.500.000" (Colombia, sin decimales)
export function leerImporte(s) {
  const txt = String(s == null ? '' : s).trim();
  if (pais.decimales === 0) return parseFloat(txt.replace(/[^0-9-]/g, ''));
  return parseFloat(txt.replace(',', '.'));
}
// Formato de número para Excel: '#,##0.00 "€"' · '"$" #,##0'
export const formatoExcel = () => (pais.decimales > 0 ? `#,##0.00 "${pais.simbolo}"` : `"${pais.simbolo}" #,##0`);

// Número para WhatsApp: si no lleva el prefijo del país, se le pone
export function numeroWhatsApp(tel) {
  const d = String(tel || '').replace(/[^0-9]/g, '');
  if (!d) return '';
  return d.startsWith(pais.prefijoTel) ? d : pais.prefijoTel + d;
}

// ── Copia de prueba ──
export const datosPrueba = () => prueba;
export const enPrueba = () => !!(prueba && prueba.activa);
// En la prueba, sacar los datos (Excel, CSV, copias) espera a que se autorice
export const exportarBloqueado = () => !!(prueba && prueba.activa && !prueba.exportAutorizada);
export const MSG_EXPORT = 'En la versión de prueba no se pueden sacar los datos. Cuando contrates la suscripción podrás descargarlos todos.';

// Descarga del ZIP con todos los datos (cuando está autorizado).
// Con la sesión abierta, o con email y contraseña desde la pantalla de entrada.
export async function descargarMisDatos({ email, password } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  const token = sessionStorage.getItem('oamatech_token');
  if (token && !email) headers.Authorization = `Bearer ${token}`;
  const r = await fetch('/api/prueba/exportar', { method: 'POST', headers, body: JSON.stringify(email ? { email, password } : {}) });
  if (!r.ok) {
    let msg = 'No se pudieron descargar los datos';
    try { msg = (await r.json()).error || msg; } catch (e) { /* sin detalle */ }
    throw new Error(msg);
  }
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `mis-datos-oamatech-${new Date().toLocaleDateString('sv-SE')}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
